import React from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'charcoal' | 'stone' | 'gradient' | 'blue';
}
export function Section({
  children,
  className = '',
  id,
  background = 'charcoal'
}: SectionProps) {
  const backgrounds = {
    charcoal: 'bg-white',
    stone: 'bg-[#F5F3FF]',
    gradient: 'bg-gradient-to-b from-white to-[#F5F3FF]',
    blue: 'bg-brand-blue'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 relative overflow-hidden ${backgrounds[background]} ${className}`} data-id="element-246">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-247">{children}</div>
    </section>;
}